import { cacaClient } from '@plangrid-private/web-api-clients';
import useSWR from 'swr';

import { useCurrentProjectId } from '@adsk/alloy-provider';

import {
  FORMS_SWR_CONFIG,
  FORM_TEMPLATES_FILTERS_DEFAULT_VALUES,
} from '../helpers/constants';
import { getFormTemplatesUrl } from '../helpers/utils';

export default () => {
  const projectId = useCurrentProjectId();
  const { data, error } = useSWR(
    getFormTemplatesUrl(projectId),
    () => {
      const fetchAllTemplates = async () => {
        const { items: initialTemplatesPage, total } =
          await cacaClient.fieldReports.getFieldReportTypes(
            projectId,
            FORM_TEMPLATES_FILTERS_DEFAULT_VALUES,
          );

        if (total === initialTemplatesPage.length) return initialTemplatesPage;

        const numRequests =
          Math.ceil(total / FORM_TEMPLATES_FILTERS_DEFAULT_VALUES.limit) - 1;

        const fetchTemplatesRequests = [];
        const fetchTemplatesPage = async (pageNum = 1) => {
          const { items } = await cacaClient.fieldReports.getFieldReportTypes(
            projectId,
            {
              ...FORM_TEMPLATES_FILTERS_DEFAULT_VALUES,
              skip: FORM_TEMPLATES_FILTERS_DEFAULT_VALUES.limit * pageNum,
            },
          );
          return items;
        };

        for (let i = 1; i <= numRequests; i++) {
          fetchTemplatesRequests.push(fetchTemplatesPage(i));
        }

        const templatesPages = await Promise.all(fetchTemplatesRequests);
        return initialTemplatesPage.concat(...templatesPages);
      };

      return fetchAllTemplates();
    },
    FORMS_SWR_CONFIG,
  );

  return {
    data,
    isError: error,
    isLoading: !error && !data,
  };
};
